/* eslint-disable no-undef*/
import { debounce, trimEnd } from 'lodash';
import { ROOT_ELEMENT_SELECTOR, SVG_ICON_SELECTOR } from './constants/app';
import { BLOG_FEED_PATH } from '@wix/communities-blog-universal/dist/src/constants/app';
import { feedButtonByBackgroundId } from './feed-buttons';
import { appLoaded } from './services/fedops-logger';
import { WIDGET_ICON_BACKGROUND_TYPE } from './constants/wix-params';
import { BACKGROUND_TYPE_SQUARE } from './constants/backgrounds';

export const getBackgroundTypeId = ({ style = {} } = {}) =>
  style.numbers ? style.numbers[WIDGET_ICON_BACKGROUND_TYPE] || BACKGROUND_TYPE_SQUARE : BACKGROUND_TYPE_SQUARE;

function createUrlGetter() {
  let siteUrl = '';
  const getUrl = (path) => `${trimEnd(siteUrl, '/')}${path}`;

  return {
    getSiteUrlForPath(path, cb) {
      if (siteUrl) {
        return cb(getUrl(path));
      } else {
        Wix.getSiteInfo(({ baseUrl }) => {
          siteUrl = baseUrl;
          return cb(getUrl(path));
        });
      }
    },
  };
}

function ensureIframeSizeMatchesContent() {
  const resizeDebounced = debounce(() => {
    const el = document.querySelector(SVG_ICON_SELECTOR);
    if (el) {
      const { height } = el.getBoundingClientRect();
      Wix.setHeight(height);
    }
  }, 20);

  window.addEventListener('resize', resizeDebounced);
}

function getWidgetBackgroundStyleId(style) {
  return getBackgroundTypeId({ style });
}

function renderWithLink(href, children) {
  return `<a href="${href}" target="_blank">${children}</a>`;
}

function renderIntoContainer(content) {
  const root = document.querySelector(ROOT_ELEMENT_SELECTOR);
  root.innerHTML = content;
}

function renderWidget(styles, getSiteUrlForPath) {
  const feedButton = feedButtonByBackgroundId[getWidgetBackgroundStyleId(styles)];

  getSiteUrlForPath(BLOG_FEED_PATH, (linkToFeed) => {
    renderIntoContainer(renderWithLink(linkToFeed, feedButton));

    appLoaded();
  });
}

export function init() {
  const { getSiteUrlForPath } = createUrlGetter();
  const renderByBackgroundStyle = (styles) => {
    renderWidget(styles, getSiteUrlForPath);
  };

  Wix.Styles.getStyleParams(renderByBackgroundStyle);
  Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, renderByBackgroundStyle);
  ensureIframeSizeMatchesContent();
}
